import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Paper, 
  TextField, 
  Button, 
  Grid,
  Alert,
  CircularProgress,
  Breadcrumbs,
  Link
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FirebaseService from '../services/FirebaseService';
import ReusableAddCertificateForm from '../components/certificate/ReusableAddCertificateForm';

const AddCertificate = () => {
  const navigate = useNavigate();
  // The ReusableAddCertificateForm will handle its own success/error messages and loading state.
  // If page-specific success/error handling is needed, it can be passed via props to ReusableAddCertificateForm.

  return (
    <Box sx={{ py: 4 }}>
      <Container maxWidth="lg">
        <Paper elevation={1} sx={{ p: 3, borderRadius: 2 }}>
          <Box sx={{ mb: 3 }}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link component={RouterLink} to="/admin/dashboard" underline="hover" color="inherit">
                Dashboard
              </Link>
              <Link component={RouterLink} to="/admin/dashboard" underline="hover" color="inherit">
                Certificates
              </Link>
              <Typography color="text.primary">Add Certificate</Typography>
            </Breadcrumbs>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
            <Typography variant="h4" component="h1">
              Add Certificate
            </Typography>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate('/admin/dashboard')}
            >
              Back
            </Button>
          </Box>
          
          {/* Use the reusable form component here */}
          {/* The ReusableAddCertificateForm will display its own success/error alerts */}
          <ReusableAddCertificateForm 
            onSuccess={() => {
              // Optionally, navigate away or show a page-level success message after a delay
              // For now, the reusable form handles its own success message and reset.
              // If navigation is desired: 
              // setTimeout(() => navigate('/admin/dashboard'), 2000);
            }}
          />

        </Paper>
      </Container>
    </Box>
  );
};

export default AddCertificate;
